import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const EmailVerificationSentModal = ({ show, handleClose, email }) => {
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      centered 
      backdrop="static" 
      keyboard={false}
      size="md"
    >
      <Modal.Body className="text-center py-5 px-4">
        <div className="mb-4">
          <div 
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
            }}
          >
            <svg 
              width="40" 
              height="40" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          
          <h4 className="fw-bold mb-3">Verification link sent to Email</h4>
          
          <p className="text-muted mb-4" style={{ fontSize: '15px', lineHeight: '1.6' }}>
            A verification link has been dispatched to your email address. Please review both your inbox and spam folder for the verification email. Once located, click on <strong>'CLICK HERE TO VERIFY YOUR EMAIL'</strong> to proceed with the login process.
          </p>
          
          {email && (
            <div 
              className="mb-4 p-3" 
              style={{ 
                backgroundColor: '#f8f9fa', 
                borderRadius: '8px',
                border: '1px solid #e9ecef'
              }}
            >
              <small className="text-muted d-block mb-1">Email sent to:</small>
              <strong style={{ color: '#495057' }}>{email}</strong>
            </div>
          )}
        </div>
        
        <Button 
          variant="primary" 
          onClick={handleClose}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            padding: '12px 40px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '8px',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
            transition: 'transform 0.2s'
          }}
          onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
        >
          OK, Got it!
        </Button>
        
        <p className="text-muted mt-4 mb-0" style={{ fontSize: '13px' }}>
          Didn't receive the email? Check your spam folder or contact support.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default EmailVerificationSentModal;